export const APP_PATH = {
  // Admin-configured reject-order reasons for this center (dropdown on the
  // Reject Order dialog). Requires ?service_type=physiotherapy
  providerRejectionReasons: "/api/v1/provider/rejection-reasons",

  // Physiotherapist Authentication
  login: "/api/v1/physiotherapist/login",
  refreshToken: "/api/v1/physiotherapist/refresh-token",
  logout: "/api/v1/physiotherapist/logout",
  validateToken: "/api/v1/auth/validate-token",
  
  // Physiotherapist Management (CRUD)
  getTherapists: "/api/v1/physiotherapist/available",
  getTherapistAssignments: "/api/v1/physiotherapist/therapists",
  createTherapist: "/api/v1/physiotherapist",
  getTherapistById: "/api/v1/physiotherapist/details",
  updateTherapistById: "/api/v1/physiotherapist/details",

  // Physiotherapist Services
  physioServices: "/api/v1/physiotherapist/services",
  physioServiceCategories: "/api/v1/physiotherapist/services/categories",

  // Physiotherapist Orders (Order Management)
  physioOrders: "/api/v1/physiotherapist/orders",
  getDoctorAppointments: "/api/v1/physiotherapist/orders",
  joinDoctorAppointment: "/api/v1/physiotherapist/orders",
  requestAppointmentReschedule: "/api/v1/physiotherapist/orders",
  createFollowupAppointment: "/api/v1/physiotherapist/orders",
  updateOnsiteSchedule: "/api/v1/physiotherapist/orders",

  // Physiotherapist Profile (physio center)
  physioProfile: "/api/v1/physiotherapist/profile",

  // Physiotherapist Addresses
  physioAddresses: "/api/v1/physiotherapist/addresses",

  // Regions catalog (governorate-level)
  regions: "/api/v1/auth/regions",

  // Physiotherapist-specific endpoints
  getConsultation: "/api/v1/consultation/me",
  getDocument: "/api/v1/consultation/documents/my-documents",
  forgotPassword: "/api/v1/consultation/forgot-password",
  resetPassword: "/api/v1/consultation/reset-password",
  forgotPasswordSendOtp: "/api/v1/physiotherapist/forgot-password/send-otp",
  forgotPasswordVerifyOtp: "/api/v1/physiotherapist/forgot-password/verify-otp",
  forgotPasswordReset: "/api/v1/physiotherapist/forgot-password/reset",
  changePassword: "/api/v1/physiotherapist/change-password",
  uploadAvatar: "/api/v1/media/upload-avatar",
  
  // Patient endpoints (if needed for physiotherapist operations)
  verifyOtp: "/api/v1/auth/patient/verify-otp",
  resendOtp: "/api/v1/auth/patient/resend-otp",
  getPatientDetails: "/api/v1/consultation/patient/details",
  // Lightweight chat participant lookup (name + presigned avatar by user id) —
  // used by the global ChatDock header on any screen (incl. general chats).
  chatParticipant: "/api/v1/consultation/chat/participant",
  
  // Notifications
  getUserNotifications: "/api/v1/notification/user",
  markNotificationRead: "/api/v1/notification",
  deleteNotification: "/api/v1/notification",
  getUnreadNotificationCount: "/api/v1/notification/unread-count",
  markAllNotificationsRead: "/api/v1/notification/mark-all-read",

  // Earnings Metrics
  physioEarningsMetrics: "/api/v1/physiotherapist/earnings/metrics",
  physioEarningsList: "/api/v1/physiotherapist/earnings/list",

  // Dashboard Orders
  physioDashboardPendingOrders: "/api/v1/physiotherapist/dashboard/pending-orders",
  physioDashboardOngoingOrders: "/api/v1/physiotherapist/dashboard/ongoing-orders",

  // Order Actions
  physioSendInvoice: "/api/v1/physiotherapist/orders",

  // Fees Configuration
  physioFeesConfiguration: "/api/v1/physiotherapist/fees/configuration",

  // Public therapist appointment (no auth)
  physioPublicOrder: "/api/v1/physiotherapist/public/orders",

  // Settlement / Payout Account (payment-service) — generic provider endpoints
  submitSettlementRequest: "/api/v1/payment/settlements/request",
  getProviderSettlements: "/api/v1/payment/settlements",
  getSettlementDashboard: "/api/v1/payment/settlements/dashboard",
  payoutAccounts: "/api/v1/payment/payout-accounts",
  getDefaultPayoutAccount: "/api/v1/payment/payout-accounts/default",

  // Consultation Chat (provider <-> patient)
  consultationChatMessages: "/api/v1/consultation/chat/messages",
  consultationChatMarkRead: "/api/v1/consultation/chat/mark-read",
  consultationChatUnreadCount: "/api/v1/consultation/chat/unread-count",
  consultationChatRooms: "/api/v1/consultation/chat/rooms",
  consultationChatUpload: "/api/v1/consultation/chat/upload",
  consultationChatDownload: "/api/v1/consultation/chat/download",
}     